const DEFAULT_BACKEND_ORIGIN =
  import.meta.env.VITE_BACKEND_ORIGIN || "https://backend.cargo-platform.online";

function normalizeLegalLocale(value) {
  const raw = String(value || "ru").toLowerCase();
  return raw.startsWith("uz") ? "uz" : "ru";
}

function normalizeAccountType(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (["client", "expeditor", "driver"].includes(raw)) return raw;
  throw new Error("LEGAL_ACCOUNT_TYPE_INVALID");
}

export function legalDocumentUrl(doc, backendOrigin = DEFAULT_BACKEND_ORIGIN) {
  const raw = String(doc?.printUrl || doc?.documentUrl || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const origin = String(backendOrigin || DEFAULT_BACKEND_ORIGIN).replace(/\/+$/, "");
  return `${origin}${raw.startsWith("/") ? raw : `/${raw}`}`;
}

export function findLegalDocument(bundle, documentNumber) {
  const target = String(documentNumber || "").trim().toUpperCase();
  return (bundle?.documents || []).find(
    (doc) => String(doc?.documentNumber || "").trim().toUpperCase() === target,
  ) || null;
}

export function legalDocumentsByObligation(bundle, obligation) {
  const target = String(obligation || "").trim().toUpperCase();
  return (bundle?.documents || []).filter(
    (doc) => String(doc?.obligation || "").trim().toUpperCase() === target,
  );
}

export async function fetchUzLegalBundle(accountType, locale, backendOrigin = DEFAULT_BACKEND_ORIGIN) {
  const safeAccountType = normalizeAccountType(accountType);
  const legalLocale = normalizeLegalLocale(locale);
  const origin = String(backendOrigin || DEFAULT_BACKEND_ORIGIN).replace(/\/+$/, "");
  const response = await fetch(
    `${origin}/api/public/legal/v5/bundle?countryCode=UZ&accountType=${encodeURIComponent(safeAccountType)}&locale=${encodeURIComponent(legalLocale)}`,
    { headers: { Accept: "application/json" } },
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data?.ok || !data?.bundle) {
    throw new Error(data?.code || "LEGAL_BUNDLE_LOAD_FAILED");
  }

  const documents = Array.isArray(data.documents) ? data.documents : [];

  return {
    locale: legalLocale,
    bundle: data.bundle,
    documents,
    presentedBundle: {
      bundleId: data.bundle.bundleId,
      bundleVersion: data.bundle.version,
      manifestSha256: data.bundle.manifestSha256,
      documents: documents.map((doc) => ({
        documentNumber: doc.documentNumber,
        version: doc.version,
        locale: doc.locale || legalLocale,
        documentSha256: doc.documentSha256,
        obligation: doc.obligation,
        acceptanceRequired: doc.acceptanceRequired !== false,
      })),
    },
  };
}
